import {ObjectUtil} from "../../../../js/util/ObjectUtil";
import {NotificationState} from "../models/NotificationState";
import {MessageType} from "../models/MessageType";
import {NotificationPreferencesRecord} from "../models/NotificationPreferencesRecord";
import {NotificationPreferenceState} from "../models/NotificationPreferenceState";

export class UserNotificationPreferences {

    private constructor(private preferences: NotificationPreferencesRecord) {

    }

    public list(): Array<NotificationPreferenceState> {
        return ObjectUtil.keys(this.preferences)
                         .sort()
                         .map((type) => {
                             const state = this.preferences[type];
                             return {
                                 type,
                                 state
                             };
                         });
    }

    public hasNotificationsAvailable(): boolean {
        return Object.keys(this.preferences).length > 0;
    }

    public has(type: MessageType): boolean {
        return type in this.preferences;
    }

    public state(type: MessageType): NotificationState {
        return this.preferences[type];
    }

    public update(type: MessageType, state: NotificationState): UserNotificationPreferences {
        const pref = ObjectUtil.merge({}, this.preferences, { [type]: state });
        return UserNotificationPreferences.create(pref);
    }

    public toggle(type: MessageType): UserNotificationPreferences {
        const current = this.preferences[type];
        const updatedState = current === NotificationState.ACTIVE ? NotificationState.DISABLED : NotificationState.ACTIVE;
        return this.update(type, updatedState);
    }

    public record(): NotificationPreferencesRecord {
        return ObjectUtil.copy(this.preferences);
    }

    public static create(response: NotificationPreferencesRecord): UserNotificationPreferences {
        return new UserNotificationPreferences(response);
    }
}
